import {Component} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '@env/environment';
@Component({selector:'app-lista-faq',templateUrl:'./lista-faq.component.html',styleUrl:'./lista-faq.component.css',standalone:false})
export class ListaFaqComponent {
  artigos:any[]=[]; artigo:any=null; filtro=''; carregando=true;
  constructor(private http:HttpClient){this.buscar();}
  buscar(){this.carregando=true;const q=this.filtro.trim()? `?busca=${encodeURIComponent(this.filtro.trim())}`:'';this.http.get<any[]>(`${environment.apiUrl}/Portal/Wiki${q}`).subscribe({next:r=>{this.artigos=r||[];this.artigo=null;this.carregando=false},error:()=>{this.artigos=[];this.carregando=false}});}
}
